import DropdownMenubar from "../Components/Menubar/DropdownMenubar";
import { BiSolidEdit } from "react-icons/bi";
import { MdDelete } from "react-icons/md";

const DD = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const getVendorInfo = (row, handleCellClick) => {
  return DD([
    {
      label: "UPDATE",
      icon: <BiSolidEdit style={{ color: " rgb(15 61 100)" }} />,
      command: () => {
        handleCellClick(row, true);
      },
    },
    {
      label: "DELETE",
      icon: <MdDelete style={{ color: " rgb(15 61 100)" }} />,
      command: () => {
        handleCellClick(row, false);
      },
    },
  ]);
};
export const columns = [
 
  {
    field: "name",
    header: "Cancellation Reason",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "name")} className="">
          <p>{row?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "userRole",
    header: "User Role",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "userRole")} className="">
          <p className="capitalize">{row?.userRole?.name}</p>
        </div>
      </>
    ),
  },
  {
    field: "action",
    header: "Action",
    // accessor: (row, handleCellClick) => (
    //   <>
    //     <div onClick={() => handleCellClick(row, "action")} className="">
    //       <BsThreeDotsVertical />
    //     </div>
    //   </>
    // ),
    accessor: (row, handleCellClick) => getVendorInfo(row, handleCellClick),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

// export const filters = [
//   {
//     filterType: "Delivery Type",
//     inputName: "order_type",
//     options: [
//       {
//         name: "Local delivery",
//         code: "LOCAL DELIVERY",
//       },
//       {
//         name: "Intercity delivery",
//         code: "INTERCITY DELIVERY",
//       },
//     ],
//   },
// ];

export const canlenderFilter = {
  filterType: "Order Date",
  inputName: "order_date",
  maxDate: new Date(),
};
